import { render, staticRenderFns } from "./FoshanUnicomElm01.vue?vue&type=template&id=1985552c&scoped=true"
import script from "./FoshanUnicomElm01.vue?vue&type=script&lang=js"
export * from "./FoshanUnicomElm01.vue?vue&type=script&lang=js"
import style0 from "./FoshanUnicomElm01.vue?vue&type=style&index=0&id=1985552c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1985552c",
  null
  
)

export default component.exports